module.exports = __webpack_public_path__ + "static/media/liva.1506103f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/liva.jpeg
// module id = 283
// module chunks = 0